<script lang="ts">
    import { onMount } from "svelte";
    import CandidatePreviewCard from "../elements/CandidatePreviewCard.svelte";
    import CurrencySelector from "../elements/CurrencySelector.svelte";
    import OverflowCtaBlock from "../elements/OverflowCTABlock.svelte";
    import { PUBLIC_CANDIDATE_SEARCH_ENDPOINT } from '$env/static/public';


    export let skills = ''
    export let roles = ''
    export let handleShowPopUp
    export let heading : string = ''

    let candidates = []
    let totalCandidates : number = 0
    let currency : 'ZAR' | 'EUR' = 'ZAR'
    let loading : boolean = true

    $ : currency

    onMount(async () => {

        const res = await fetch(PUBLIC_CANDIDATE_SEARCH_ENDPOINT, {
            method: 'POST',
            headers: {
                'accepts': 'application/json',
                'Content-Type' : 'application/json'
            },
            body: JSON.stringify({skills, roles})
        })
         candidates = await res.json()
       
        totalCandidates = candidates.length

        loading = false
    })

    const setCurrency = (event) => {
        currency = event.detail.currency
    }
</script>

<div class="marketplace-preview" style:margin={totalCandidates === 0 ? '0px' : ''}>
    {#if heading}<h2>{heading}</h2>{/if}
    { #if loading }
        <div class="loader">
            <span></span>
            <span></span>
            <span></span>
        </div>
    { :else if totalCandidates === 0 }
        <div class="info-card">
            <p class="info-card__highlight">There aren't currently candidates that match this role 😢</p>
            <p>Every Monday 100+ new developers are added, so there is a good chance we'll have candidates that you're looking for soon.</p>
        </div>
    { :else }
        <div class="marketplace-preview__content">
            <p class="marketplace-preview__content__heading">Browse {totalCandidates} job-seeking developers</p>
            <div class="marketplace-preview__content__options">
                <p><button on:click={handleShowPopUp}>Get access to developers</button> to talk to them</p>
                <CurrencySelector on:notify={setCurrency} {currency}/>
            </div>
        </div>
        <div class="marketplace-preview__cards">
            {#each candidates.slice(0, 6) as candidate, i}
                <CandidatePreviewCard
                    {candidate}
                    searchTerm={skills}
                    roleSearchTerm={roles}
                    {currency}
                    handleShowPopUp={handleShowPopUp}
                    totalCandidates={totalCandidates}
                    index={i}
                />
            {/each}
        </div>
        <OverflowCtaBlock total={totalCandidates}/>
    {/if}
</div>


<style lang="postcss">

    @import '../../styles/_mixins.css';
    .marketplace-preview {

        position: relative;
        margin:120px 0;
        max-width:1200px;
        width:100%;

        & h2 {
            text-align: center;
            @mixin heading-h2;
            color:var(--color_offerzen_navy);
            margin:0 0 60px;

            @mixin screen-md { 
                padding:0 60px;
            }

            @mixin screen-sm {
                text-align:left;
                padding:0 24px;
                margin:0px 0 16px;
            }
        }

        & .info-card {
            background-color: var(--color_white);
            display: flex;
            align-items: center;
            flex-direction: column;
            max-width: 815px;
            width: 100%;
            color:var(--color_offerzen_navy);
            padding:60px;
            line-height: 140%;
            text-align: center;
            margin: auto;
            z-index: 1;
            font-size:18px;

            & .info-card__highlight {
                font-weight:700;
            }

            & p {
                margin:0;
            }
        }
        & .marketplace-preview__cards {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap:24px;
            @mixin screen-lg {
                padding:0 80px;
            }

            @mixin screen-md {
                grid-template-columns: 1fr 1fr;
                padding:0 60px;
            }

            @mixin screen-sm {
                grid-template-columns: 1fr;
                padding:0 24px;
                gap:24px;
            }
        }

        & .marketplace-preview__content {
            display: flex;
            flex-direction: column;
            margin:0 0 24px;
            justify-content: center;

            @mixin screen-lg {
                padding:0 80px;
            }

            @mixin screen-md {
                padding:0 60px;
            }

            @mixin screen-sm {
                padding:0 24px;
            }

            & .marketplace-preview__content__heading {
                color:var(--color_offerzen_navy);
                font-size:24px;
                line-height: 120%;
                font-weight: 700;
                margin:0 0 6px;
            }

            & .marketplace-preview__content__options {
                display: flex;
                justify-content: space-between;

                & p {
                    margin:0;
                    color:var(--color_offerzen_navy);
                }

                & button {
                    color:#ba69c8;
                    background-color: transparent;
                    border:none;
                    padding: 0;
                }

                @mixin screen-sm {
                    flex-direction:column;
                }
            }
        }

        & .loader {
            text-align: center;
            margin:0 !important;
        }
        & .loader span {
            display: inline-block;
            vertical-align: middle;
            width: 12px;
            height: 12px;
            background: var(--color_offerzen_cerulean);
            border-radius: 20px;
            animation: loader 1s infinite alternate;
        }
        & .loader span:nth-of-type(2) {
            animation-delay: 0.2s;
        }
        & .loader span:nth-of-type(3) {
            animation-delay: 0.6s;
        }

        @mixin screen-md {
            margin:80px 0;
        }

        @mixin screen-sm {
            margin:60px 0;
        }
    }

    @keyframes loader {
            0% {
                opacity: 0.9;
                transform: scale(0.5);
            }
            100% {
                opacity: 0.1;
                transform: scale(1);
            }
        }
</style>